import { render, staticRenderFns } from "./ClientInformationContainer.vue?vue&type=template&id=79626a2e&scoped=true&"
import script from "./ClientInformationContainer.vue?vue&type=script&lang=js&"
export * from "./ClientInformationContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79626a2e",
  null
  
)

export default component.exports